const initialState = {
	data: [],
	total: 0,
	params: {},
}

const casinohistory = (state = initialState, action) => {
	switch (action.type) {
		case 'CASINOHISTORY_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		default:
			return state
	}
}

export default casinohistory
